import { Namespace } from "../Namespaces";

export default class SVGFactory {

  public static create<T extends SVGElement>(
    elementTag: string,
    attributes: Record<string, string | number>
  ): T {
    const newElement = document.createElementNS(Namespace.SVG, elementTag) as T;
    
    Object.keys(attributes).forEach((key) => {
      newElement.setAttribute(key, `${attributes[key]}`);
    });
    
    return newElement;
  }
}
